import { render, staticRenderFns } from "./custom-scope-picker.vue?vue&type=template&id=7915855f&scoped=true&"
import script from "./custom-scope-picker.vue?vue&type=script&lang=js&"
export * from "./custom-scope-picker.vue?vue&type=script&lang=js&"
import style0 from "./custom-scope-picker.vue?vue&type=style&index=0&id=7915855f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7915855f",
  null
  
)

export default component.exports